import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const ChgSevenForm = () => {

    // Company Info (Single Entry)
    const [companyInfo, setCompanyInfo] = useState(() => {
        const saved = localStorage.getItem("chg7_company_info");
        return saved ? JSON.parse(saved) : {
            companyName: "",
            registeredOffice: "",
        };
    });

    const handleCompanyChange = (field, value) => {
        const updated = { ...companyInfo, [field]: value };
        setCompanyInfo(updated);
        localStorage.setItem("chg7_company_info", JSON.stringify(updated));
    };

    // Multiple Charge Entries
    const [entries, setEntries] = useState(() => {
        const saved = localStorage.getItem("chg7_register_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("chg7_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries(prev => prev.map(entry =>
            entry.id === id ? { ...entry, [field]: value } : entry
        ));
    };

    const addEntry = () => {
        setEntries([...entries, { id: Date.now() }]);
    };

    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter(e => e.id !== id));
        }
    };

    const handleSave = () => {
  const payload = {
    formType: "CHG-7",
    generatedAt: new Date().toISOString(),

    companyInfo: {
      companyName: companyInfo.companyName || "",
      registeredOffice: companyInfo.registeredOffice || "",
      place: companyInfo.place || "",
      date: companyInfo.date || "",
      signature: companyInfo.signature || ""
    },

    totalChargeEntries: entries.length,

    entries: entries.map(entry => ({
      entryId: entry.id,

      sNo: entry.sNo || "",
      chargeId: entry.chargeId || "",
      creationDate: entry.creationDate || "",
      regCreationDate: entry.regCreationDate || "",
      propertyDesc: entry.propertyDesc || "",
      periodAmount: entry.periodAmount || "",
      holderDetails: entry.holderDetails || "",
      terms: entry.terms || "",
      instrumentCreate: entry.instrumentCreate || "",
      modificationDate: entry.modificationDate || "",
      modRegDate: entry.modRegDate || "",
      instrumentModify: entry.instrumentModify || "",
      modificationDetails: entry.modificationDetails || "",
      satisfactionDate: entry.satisfactionDate || "",
      satRegDate: entry.satRegDate || "",
      condonation: entry.condonation || "",
      delayReason: entry.delayReason || ""
    }))
  };

  console.log("CHG-7 FINAL PAYLOAD:", JSON.stringify(payload, null, 2));

};


    return (
        <div>
            
            <div className="bg-white px-6 py-2 mb-4 border-b-4 shadow-sm rounded-t-lg text-center">
                <h1 className="text-2xl text-gray-900 uppercase tracking-tight">Form No. CHG - 7</h1>
                <h2 className="text-lg font-semibold">Register of Charges</h2>
                <p className="text-[10px] italic text-slate-500 mt-2">
                    [Pursuant to section 85 and sub-rule (1) of rule 10 of the Companies (Registration of Charges) Rules, 2014]
                </p>
            </div>

            <div className="space-y-12">
                {entries.map((entry, index) => (
                    <div key={entry.id} className="bg-white border border-slate-200 rounded-xl shadow-md">
                        
                        <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                            <span className="font-bold text-xs uppercase tracking-widest">
                                Charge Entry No: {index + 1}
                            </span>
                            {entries.length > 1 && (
                                <button onClick={() => deleteEntry(entry.id)} className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 uppercase">
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, "sNo", v)} />
                            <FormField label="(2) Charge ID" value={entry.chargeId} onChange={(v) => updateField(entry.id, "chargeId", v)} />
                            <FormField label="(3) Date of creation of charge or acquisition" type="date" value={entry.creationDate} onChange={(v) => updateField(entry.id, "creationDate", v)} />
                            <FormField label="(4) Date of registration of creation of charge" type="date" value={entry.regCreationDate} onChange={(v) => updateField(entry.id, "regCreationDate", v)} />
                            <FormField label="(5) Short description of property charged" type="description" value={entry.propertyDesc} onChange={(v) => updateField(entry.id, "propertyDesc", v)} />
                            <FormField label="(6) Period and amount secured by the charge" type="description" value={entry.periodAmount} onChange={(v) => updateField(entry.id, "periodAmount", v)} />
                            <FormField label="(7) Names & addresses of charge holder" type="description" value={entry.holderDetails} onChange={(v) => updateField(entry.id, "holderDetails", v)} />
                            <FormField label="(8) Particulars of the terms and conditions of the charge" type="description" value={entry.terms} onChange={(v) => updateField(entry.id, "terms", v)} />
                            <FormField label="(9) Description of the instrument creating the charge" type="description" value={entry.instrumentCreate} onChange={(v) => updateField(entry.id, "instrumentCreate", v)} />
                            <FormField label="(10) Date of modification of charge" type="date" value={entry.modificationDate} onChange={(v) => updateField(entry.id, "modificationDate", v)} />
                            <FormField label="(11) Date of registration of modification of charge" type="date" value={entry.modRegDate} onChange={(v) => updateField(entry.id, "modRegDate", v)} />
                            <FormField label="(12) Description of the instrument modifying the charge" type="description" value={entry.instrumentModify} onChange={(v) => updateField(entry.id, "instrumentModify", v)} />
                            <FormField label="(13) Particulars of modification" type="description" value={entry.modificationDetails} onChange={(v) => updateField(entry.id, "modificationDetails", v)} />
                            <FormField label="(14) Date of satisfaction" type="date" value={entry.satisfactionDate} onChange={(v) => updateField(entry.id, "satisfactionDate", v)} />
                            <FormField label="(15) Registration date of satisfaction" type="date" value={entry.satRegDate} onChange={(v) => updateField(entry.id, "satRegDate", v)} />
                            <FormField label="(16) Facts and date of condonation of delay, if any" type="description" value={entry.condonation} onChange={(v) => updateField(entry.id, "condonation", v)} />
                            <FormField label="(17) Reasons for delay in filing for registration of creation, modification or satisfaction of the charge, if any" type="description" value={entry.delayReason} onChange={(v) => updateField(entry.id, "delayReason", v)} />
                        </div>
                    </div>
                ))}
            </div>

            <Button
            label="Add New Charge Entry"
            className="mt-2"
                onClick={addEntry}
            />

            <div className="mt-2 bg-white p-6 rounded-lg shadow grid grid-cols-1 md:grid-cols-3 gap-6">
                <FormField label="Place" value={companyInfo.place} onChange={(v) => handleCompanyChange("place", v)} />
                <FormField label="Date" type="date" value={companyInfo.date} onChange={(v) => handleCompanyChange("date", v)} />
                <FormField label="Signature (MD/Director)" value={companyInfo.signature} onChange={(v) => handleCompanyChange("signature", v)} />
            </div>
<Button
  label="Save CHG-7 Register"
  className="mt-4 bg-green-600 hover:bg-green-700"
  onClick={handleSave}
/>

        </div>
    );
};

export default ChgSevenForm;
